import { render, staticRenderFns } from "./ShapeRecognitionQuestion.vue?vue&type=template&id=624c572c&scoped=true"
import script from "./ShapeRecognitionQuestion.vue?vue&type=script&lang=js"
export * from "./ShapeRecognitionQuestion.vue?vue&type=script&lang=js"
import style0 from "./ShapeRecognitionQuestion.vue?vue&type=style&index=0&id=624c572c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624c572c",
  null
  
)

export default component.exports